/**
 * tab ⇄ reader 导航会话标记。
 * enter_tab / stay_tab 埋点仅覆盖 reader 与首页三个 tab 的闭环：
 * - reader 卸载且去向为 tab 页时打标记，TabBar 进入 tab 页时消费标记补发 ENTER_TAB；
 * - tab 进入 reader 时由 TabBar 记录 reader 会话，返回 tab 页时消费会话补发 reader 的 STAY_TAB。
 * 模块级变量：reader 与 TabBar 分属不同路由子树，随导航卸载/重挂载，
 * 需跨组件生命周期共享（覆盖首次直接打开 reader 再返回首页的场景）。
 */

import { ROUTER } from '@/constants';

/** 判断路径是否为首页三个 tab 之一 */
export function isTabPath(path: string): boolean {
    return path === ROUTER.MY_LIST || path === ROUTER.DISCOVER || path === ROUTER.PROFILE;
}

let leftReaderToTab = false;

/** reader 离开且去向为 tab 页时调用 */
export function markLeftReaderToTab(): void {
    leftReaderToTab = true;
}

/** TabBar 进入 tab 页时调用；返回是否来自 reader（消费后复位） */
export function consumeLeftReaderToTab(): boolean {
    const left = leftReaderToTab;
    leftReaderToTab = false;
    return left;
}

/** reader 会话：tab → reader 时记录，用于返回 tab 时补报 reader 的 stay_tab */
export interface IReaderSession {
    /** 进入 reader 的时间戳 */
    enterAt: number;
    /** 来源 tab（埋点上报名） */
    fromTab: string;
}

let readerSession: IReaderSession | null = null;

/** tab 进入 reader 时由 TabBar 调用，记录 reader 会话 */
export function markEnteredReader(fromTab: string): void {
    readerSession = { enterAt: Date.now(), fromTab };
}

/** 从 reader 返回 tab 时调用；返回 reader 会话（消费后复位），无记录返回 null */
export function consumeReaderSession(): IReaderSession | null {
    const session = readerSession;
    readerSession = null;
    return session;
}

/** reader 卸载且去向非 tab 页时调用，清掉会话避免脏数据流入下次闭环 */
export function clearReaderSession(): void {
    readerSession = null;
}

/** enter_tab / stay_tab 的 enter_type 取值 */
export type TTabEnterType = 'launch_app' | 'switch';

/**
 * 本次页面会话内是否已上报过 enter_tab。
 * 模块级变量：TabBar 随 tab ⇄ reader 导航卸载/重挂载，组件内 ref 会在重挂载后丢失，
 * 需跨组件生命周期共享，保证"首个 enter_tab 为 launch_app，其后均为 switch"。
 */
let enterTabReported = false;

/** 消费 enter_type：首个 enter_tab 返回 launch_app 并置位，其后均返回 switch */
export function consumeEnterTabType(): TTabEnterType {
    const type: TTabEnterType = enterTabReported ? 'switch' : 'launch_app';
    enterTabReported = true;
    return type;
}
